// extracted by mini-css-extract-plugin
export var button = "_ap-0";
export var icon = "_ap-1";